<template>
  <el-progress
    type="circle"
    v-bind="$attrs"
    :percentage="progresso"
    :width="espessura"
    :stroke-width="linha"
  >
    <span />
  </el-progress>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  percent: string;
  width: string;
  strokeWidth: string;
}>();

const progresso = computed(() => {
  return Number(props.percent);
});

const espessura = computed(() => {
  return Number(props.width);
});

const linha = computed(() => {
  return Number(props.strokeWidth);
});
</script>

<style lang="sass" scoped></style>
